import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Button extends Component {
  static propTypes = {
    ariaLabel: PropTypes.string,
    backgroundColor: PropTypes.string,
    border: PropTypes.string,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    href: PropTypes.string,
    icon: PropTypes.string,
    iconClassName: PropTypes.string,
    iconLeftAligned: PropTypes.bool,
    isSubmit: PropTypes.bool,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    role: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'lg', 'lg-wide']),
    tabIndex: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    transitional: PropTypes.bool,
    type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'google', 'facebook', 'none', 'blank', 'link']),
  };

  static defaultProps = {
    ariaLabel: null,
    backgroundColor: null,
    border: null,
    className: '',
    dataTestId: null,
    disabled: false,
    fullWidth: false,
    iconLeftAligned: true,
    isSubmit: false,
    role: '',
    tabIndex: '',
    text: '',
    transitional: false,
    type: 'primary',
    onClick: () => {},
    onMouseEnter: () => {},
    onMouseLeave: () => {},
  };

  onClick = e => {
    this.props.onClick(e);
    if (this.props.href) {
      window.location.href = this.props.href;
    }
  };

  render() {
    const {
      ariaLabel,
      border,
      backgroundColor,
      className,
      dataTestId,
      disabled,
      fullWidth,
      icon,
      id,
      iconLeftAligned,
      isSubmit,
      iconClassName,
      role,
      size,
      text,
      children,
      tabIndex,
      transitional,
      type,
      onMouseEnter,
      onMouseLeave,
    } = this.props;

    const classes = classNames({
      'btn--full-width': fullWidth,
      'btn--transitional': transitional,
      btn: true,
      [`btn-${type}`]: !!type,
      [`btn-${size}`]: !!size,
      [className]: className,
    });

    const iconClasses = classNames({
      icon: true,
      [`icon-${icon}`]: true,
      [iconClassName]: !!iconClassName,
    });

    const styles = {
      border,
      backgroundColor,
    };

    const buttonText = text || children;

    const extraProps = {};
    if (id) extraProps.id = id;
    if (dataTestId) extraProps['data-test-id'] = dataTestId;
    // Accessibility
    if (tabIndex) extraProps.tabIndex = tabIndex;
    if (role) extraProps.role = role;

    return (
      <button
        aria-label={ariaLabel}
        className={classes}
        disabled={disabled}
        style={styles}
        type={isSubmit ? 'submit' : 'button'}
        onClick={this.onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...extraProps}
      >
        {icon && iconLeftAligned && <span className={iconClasses} />}
        {icon && iconLeftAligned && ' '}
        {buttonText}
        {transitional && <span className="icon icon-right-open" />}
        {icon && !iconLeftAligned && ' '}
        {icon && !iconLeftAligned && <span className={iconClasses} />}
      </button>
    );
  }
}
